import React, { useEffect, useState } from 'react'
import LocationSearch from './LocationSearch'
import { useFirestore } from 'reactfire';
import { collection, doc, onSnapshot, query } from 'firebase/firestore';
import { Collections } from '../utils/shared/constants';
import TrialInfo from './TrialInfo';
import { requestManualImport, updateReviews } from '../utils/api';
import { Button, FormField } from '@wix/design-system';
import { ArrowLeft } from '@wix/wix-ui-icons-common';
import { Place } from '../models/shared/Place';
import { fromFirebaseDoc } from '../utils/shared/firebase';
import { useInstanceData } from '../hooks/useInstanceData';
import BaseSettings from './BaseSettings';
import AppReviewRequest from './AppReviewRequest';
import BusinessLocation from './BusinessLocation';
import 'rc-slider/assets/index.css';
import BusinessSettings from './BusinessSettings';
import { useSettingsContext } from '../context/SettingsContext';

const BACKFILL_TRIGGER = 5;

export default function SettingsDisplay() {
    const db = useFirestore();
    const [forceSearchLocation, setForceSearchLocation] = React.useState(false);
    const [reviewCount, setReviewCount] = React.useState(9999);
    const [place, setPlace] = useState<Place | null>(null);
    const { onTrial, instanceData } = useInstanceData();
    const { settings, setProcessing } = useSettingsContext();

    const handleLocationChosen = () => {
        setForceSearchLocation(false);
    }

    useEffect(() => {
        const placeId = settings?.placeId;
        if (!placeId) {
            return;
        }
        const unsubscribePlace = onSnapshot(doc(db, Collections.places, placeId), snapshot => {
            setPlace(fromFirebaseDoc<Place>(snapshot))
        });

        const reviewCol = collection(db, Collections.places, placeId, Collections.reviews);
        const unsubscribeCount = onSnapshot(query(reviewCol), snapshot => {
            setReviewCount(snapshot.size);
        })

        return () => {
            unsubscribePlace();
            unsubscribeCount();
        }
    }, [db, settings?.placeId])

    if (!settings) {
        return <div className='center mt-2'>
            <div className='spinner-border' />
        </div>
    }

    const handleReviewsImport = async () => {
        const instanceId = instanceData?.instanceId;
        if (!instanceId) {
            return;
        }

        setProcessing(true);
        if (settings.manual) {
            await requestManualImport(settings.placeUrl || '', true);
        } else {
            await updateReviews(instanceId);
        }
        setProcessing(false);
    }

    const searchLocation = forceSearchLocation || !settings.placeId;

    if (searchLocation) {
        return <div className='settings'>
            <TrialInfo className='settings-trial' location='settings' />
            <div className='section'>
                <div className='d-flex justify-content-between'>
                    <FormField label="Business" />
                    {settings.placeId && <Button size='tiny' prefixIcon={<ArrowLeft />} onClick={() => setForceSearchLocation(false)}>Back</Button>}
                </div>

                <LocationSearch onLocationChosen={handleLocationChosen} />
            </div>
        </div>
    }

    const showBackfillInfo = !settings.manual && reviewCount === BACKFILL_TRIGGER;
    return (
        <div className='settings'>
            <TrialInfo className='settings-trial' location='settings' />

            <BusinessLocation
                place={place}
                onTrial={onTrial}
                onEditLocation={() => setForceSearchLocation(true)}
                onImportReviews={handleReviewsImport}
            />

            <BaseSettings />

            <BusinessSettings
                instanceData={instanceData}
            />

            {showBackfillInfo &&
                <>
                    <hr />
                    <div className='section mt-3'>
                        <div className='center flex-column'>
                            <p className='text-muted text-justify mt-0'><i className='bi bi-info-circle' /> It can take up to one hour to fetch reviews for all 20 slots</p>
                        </div>
                    </div>
                </>}

            <AppReviewRequest />
        </div>
    )
}

